import pluralize from 'pluralize'

pluralize.addSingularRule(/en$/i, '')
pluralize.addPluralRule(/lid$/i, 'leden')
pluralize.addPluralRule(/omzetgroep$/i, 'omzetgroepen')
pluralize.addPluralRule(/en$/, 'en')
pluralize.addPluralRule('vraag', 'vragen')
pluralize.addPluralRule('artikel', 'artikelen')
pluralize.addPluralRule('bericht', 'berichten')
pluralize.addSingularRule('event_series', 'event_series')
pluralize.addSingularRule('eventSeries', 'eventSeries')
